import { env } from '@/lib/env'

/**
 * Normalizes a bare host (or a verbatim `http://localhost:<port>` value) into
 * the full origin `window.location.ancestorOrigins` reports. Shared with
 * `src/lib/apple-pay-parent-host.ts` so both allow-lists agree on shape.
 */
export function normalizeToOrigin(host: string): string {
  if (host.startsWith('http://localhost')) return host
  return `https://${host}`
}

/**
 * Full expected HPP origin (scheme + host) for the resolved env.
 * Returns `null` when `env.HPP_DOMAIN_NAME` is empty — callers should
 * skip attaching the inbound `postMessage` listener in that case
 * (the `/hpp-session` route still works via `?showButton=1`).
 */
export function expectedHppOrigin(): string | null {
  if (!env.HPP_DOMAIN_NAME) return null
  return normalizeToOrigin(env.HPP_DOMAIN_NAME)
}
